export interface Config {
  realms: ConfigGroupRealm[]
  groupMasks: ConfigGroupMask[]
}

export interface ConfigGroupRealm {
  id: string
  name: string
  targets: string[]
}

export interface ConfigGroupMask {
  name: string
  prefix: string
  targets: string[]
}

export interface InitialAlias {
  alias: string
  description: string
  expires: string
}

export interface GroupCreateRequest {
  aliases: InitialAlias[]
}

export interface Group {
  name: string
  email: string
  members: string[]
  aliases: string[]
  createRequest?: GroupCreateRequest
}

export interface Alias {
  group: string
  alias: string
  description: string
  expires: string // YYYY-MM-DD or empty string
}

export interface AliasConflict {
  enabled: string
  disabled: string
}

export const ALIAS_DISABLED_SUFFIX = '___disabled'

export const isAliasDisabled = (alias: string): boolean =>
  alias.split('@')[0].endsWith(ALIAS_DISABLED_SUFFIX)

export const aliasDisplayEmail = (alias: string): string =>
  isAliasDisabled(alias)
    ? alias.replace(`${ALIAS_DISABLED_SUFFIX}@`, '@')
    : alias

export const idToString = (data: string): string[] => [data]

export interface AliasKey {
  group: string
  alias: string
}

export const aliasIdToString = (data: AliasKey): string[] => [
  data.group,
  'aliases',
  data.alias
]
